import React from "react"

import BrokerGuidancePanel from "./BrokerGuidancePanel"
import {
  ChecklistRow,
  GuidanceAccordionBody,
  GuidanceBlock,
  GuidanceIntro,
} from "./ibkrGuidanceShared"

export interface TradingViewPaperGuidanceProps {
  compact?: boolean
  /** When false, omit Tessera account-name copy (demo has no account chrome). */
  showAccountNotes?: boolean
}

const TradingViewPaperGuidance = ({
  compact = false,
  showAccountNotes = true,
}: TradingViewPaperGuidanceProps): React.ReactElement => {
  return (
    <BrokerGuidancePanel
      title="How to export TradingView Paper Trading"
      compact={compact}
      collapsible
    >
      <GuidanceAccordionBody>
        <GuidanceIntro className="!mb-0">
          Export Paper Trading Order History as CSV (ideally with all columns). This is not Strategy
          Tester. Use TradingView Backtest for List of Trades exports.
        </GuidanceIntro>

        <GuidanceBlock title="Export steps">
          <ChecklistRow className="!mb-0">
            Open Trading Panel → Paper Trading → Order History → export CSV
          </ChecklistRow>
          <ChecklistRow className="!mb-0">
            Symbols come from the file (e.g. OANDA:XAUUSD → XAUUSD)
          </ChecklistRow>
        </GuidanceBlock>

        <GuidanceBlock title="In Tessera">
          {showAccountNotes ? (
            <ChecklistRow className="!mb-0">
              Use Account name to label this paper account. Executing broker is usually Paper.
            </ChecklistRow>
          ) : null}
          <ChecklistRow className="!mb-0">
            Match Timezone to the timezone used in the export timestamps. Stop-loss and take-profit
            are attached when bracket Limit/Stop orders appear near the entry in the file.
          </ChecklistRow>
        </GuidanceBlock>
      </GuidanceAccordionBody>
    </BrokerGuidancePanel>
  )
}

export default TradingViewPaperGuidance
